/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Fabien SERRA
 * @date        21/09/2021 10:25
 * @copyright   Copyright (c) 2002-2021 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import '@blocks/road-trip/scripts/lib/storymapAdvanced'

export default class Block {
    constructor() {
        Block.story_map()
    }

    static story_map() {
        const roadTripBlock = $('[data-id="road-trip-block"]')

        roadTripBlock.each(function () {
            const block = $(this),
                roadTripList = block.find('[data-id="road-trip-list"]'),
                roadTripMap = block.find('[data-id="road-trip-map"]'),
                roadTripMapContainer = block.find('[data-id="road-trip-map-container"]'),
                roadTripScreenMode = '[data-trigger="road-trip-screenmode"]'

            if (roadTripList.length > 0) {
                const trace = roadTripMap.data('trace')
                let traceType = ''

                if (trace) {
                    if (trace.indexOf('.kml') > -1) {
                        traceType = 'kml'
                    } else if (trace.indexOf('.gpx') > -1) {
                        traceType = 'gpx'
                    }
                }

                const args = {
                    id: roadTripMap.attr('id'),
                    trace: roadTripMap.data('trace'),
                    trace_type: traceType,
                    trace_color: roadTripMap.data('trace-color'),
                    current_block: block,
                }

                if (roadTripBlock.find('[data-trigger-eco-block="map"]').length > 0) {
                    $(block).on('click', '[data-trigger-eco-block="map"]', () => {
                        block.storymapAdvanced(args)
                        block.find('[data-eco-block="roadtrip-map"]').trigger('eco-block-loaded')
                    })
                } else {
                    roadTripList.storymapAdvanced(args)
                }
            }

            $(document).on('click', roadTripScreenMode, function (e) {
                e.preventDefault()
                roadTripMapContainer.toggleClass('full')
                $(roadTripScreenMode).children('b').toggleClass('hide')
                $(document).trigger('update_roadtrip_map', this)
            })
        })
    }
}
